"use client";

import { CommonDialog } from "./CommonDialog";

interface IncompleteReservationModalProps {
  open: boolean;
  // Text customization props for internationalization
  title?: string;
  firstParagraph?: string;
  secondParagraph?: string;
}

export function IncompleteReservationModal({
  open,
  // Default to English as per Figma design
  title = "Warninggggg",
  firstParagraph = "We've noticed you already have an incomplete reservation in another browser tab. To avoid a possible double booking, please close this window.",
  secondParagraph = "If you need to open another tab, please use a different browser or incognito mode.",
}: Readonly<IncompleteReservationModalProps>) {
  return (
    <CommonDialog
      open={open}
      onOpenChange={() => {}} // Prevent closing by clicking outside
      contentClassName="p-2"
      closeOnOverlayClick={false}
      closeOnEsc={false}
      showCloseButton={false}
      title={<span className="text-lg font-semibold text-white">{title}</span>}
      titleClassName="bg-destructive p-4 rounded-sm"
      description={
        <div className="space-y-4">
          <p className="text-base text-black">{firstParagraph}</p>
          <p className="text-base text-black">{secondParagraph}</p>
        </div>
      }
      descriptionClassName="py-4 px-0"
      footerClassName="hidden" // No buttons, user must close tab
    />
  );
}

export default IncompleteReservationModal;
